import Accordion from "@components/HourlyMain/Accordion";
import { useDispatch, useSelector } from "react-redux";
import { homeStateSelector, setHomeState } from "@/store/redux/modules/home";
import GoogleMap from "./GoogleMap";
import { refreshUserLocation } from "@/components/BasicLayout/BasicHeader/LocationMask";
import { pxChangeVw } from "@/utils";
import { useTranslation } from "react-i18next";
const AlertDetail: React.FC = () => {
  const homeState = useSelector(homeStateSelector);
  const [city, setCity] = useState<any>({});
  const [alertDetail, setAlertDetail] = useState([]);
  const dispatch = useDispatch();
  const localSelectCity = LocalStorage.getItem("select_city");
  const fetchData = async (keyId: any = undefined) => {
    const res = await alertApi.query({
      test: isDevEnv ? 1 : undefined,
      keyId: keyId || localSelectCity?.Key || homeState?.info?.key || LocalStorage.getItem("info")?.key,
    });
    res?.data?.alertDetail?.length &&
      res.data.alertDetail.forEach((item: any) => {
        item.isExpand = false;
      });
    LocalStorage.setItem("info", res.data.baseInfo);
    dispatch(setHomeState({ info: res.data.baseInfo }));
    setAlertDetail(res.data.alertDetail);
    setCity(res.data.city);
  };
  useEffect(() => {
    if (!(homeState?.info?.key || LocalStorage.getItem("info")?.key || localSelectCity?.Key)) {
      refreshUserLocation(dispatch);
    } else {
      fetchData();
    }
  }, [homeState?.info?.key || LocalStorage.getItem("info")?.key]);
  const { t: $t } = useTranslation();
  const renderTitle = (item: any, _index: number, handleClick: Function) => {
    return (
      <>
        <div className="flex justify-between items-center text-12" onClick={() => handleClick(item, _index)}>
          <div className="w-full border-b-1 border-b-solid border-b-[rgba(255,255,255,0.18)] pb-15 flex flex-col gap-y-4">
            <div className="flex justify-between items-center gap-x-4">
              <div className="flex items-center gap-x-8">
                <AlertSvg color={`rgba(${item?.Color?.Red}, ${item?.Color?.Green}, ${item?.Color?.Blue}, 0.3)`} />
                <div
                  className="color-[var(--data-color)]"
                  style={{
                    // @ts-ignore
                    "--data-color": `rgba(${item?.Color?.Red}, ${item?.Color?.Green}, ${item?.Color?.Blue}, 0.7)`,
                  }}
                >
                  {item?.Description?.Localized}
                </div>
              </div>
              <SvgIcon name={item.isExpand ? "arrow_up" : "arrow_down"} />
            </div>
            <div className="flex items-center gap-x-16 text-12">
              <div>{$t("title16")}</div> <div>{item?.Source}</div>
            </div>
          </div>
        </div>
      </>
    );
  };
  const renderContent = (item: any, index: number) => {
    return (
      <div className="flex flex-col gap-y-8 text-12">
        <div className="flex flex-col gap-y-8">
          <p className={index === 0 ? "flex justify-between items-center" : ""} style={{ opacity: 0.8 }}>
            <i>{$t("title17")}</i>
            <i>{$t("title18")}</i>
          </p>
          <p
            className={index === 0 ? "flex justify-between items-center" : ""}
            style={{ fontSize: pxChangeVw("16px") }}
          >
            <i>{item?.detail?.start}</i>
            <i>{item?.detail?.end}</i>
          </p>
          <p className={index === 0 ? "flex justify-between items-center" : ""}>
            <i>{item?.detail?.start_week}</i>
            <i>{item?.detail?.end_week}</i>
          </p>
          <div style={{ width: "100%", height: pxChangeVw("180px") }}>{city.geo && <GoogleMap {...city.geo} />}</div>
          <p
            className={index === 0 ? "flex justify-between items-center" : ""}
            style={{
              justifyContent: "flex-start",
              alignItems: "flex-start",
            }}
          >
            {item?.detail?.Summary}
          </p>
        </div>
      </div>
    );
  };
  return (
    <div className="flex flex-col justify-start gap-y-10 p-[0_16px] box-border">
      {!!alertDetail?.length && (
        <Accordion
          list={alertDetail}
          setLocalList={setAlertDetail}
          renderTitle={renderTitle}
          renderContent={renderContent}
        />
      )}
    </div>
  );
};
export default AlertDetail;
